module.exports = __webpack_public_path__ + "img/swift-boosterjet-gris-acero.2840b5b7.png";